import {
	BarChart3,
	Calendar,
	TrendingUp,
	Bot,
	GraduationCap,
	Target,
} from 'lucide-react';
import { useIntl } from 'react-intl';
import styles from './KeyFeaturesSection.module.css';
import ContourBackdrop from '../../../../components/ContourBackdrop/ContourBackdrop';

const KeyFeaturesSection = () => {
	const intl = useIntl();
	const features = [
		{
			icon: BarChart3,
			title: intl.formatMessage({ id: 'KeyFeaturesId3' }),
			description: intl.formatMessage({ id: 'KeyFeaturesId4' }),
		},
		{
			icon: Calendar,
			title: intl.formatMessage({ id: 'KeyFeaturesId5' }),
			description: intl.formatMessage({ id: 'KeyFeaturesId6' }),
		},
		{
			icon: TrendingUp,
			title: intl.formatMessage({ id: 'KeyFeaturesId7' }),
			description: intl.formatMessage({ id: 'KeyFeaturesId8' }),
		},
		{
			icon: Bot,
			title: intl.formatMessage({ id: 'KeyFeaturesId9' }),
			description: intl.formatMessage({ id: 'KeyFeaturesId10' }),
		},
		{
			icon: GraduationCap,
			title: intl.formatMessage({ id: 'KeyFeaturesId11' }),
			description: intl.formatMessage({ id: 'KeyFeaturesId12' }),
		},
		{
			icon: Target,
			title: intl.formatMessage({ id: 'KeyFeaturesId13' }),
			description: intl.formatMessage({ id: 'KeyFeaturesId14' }),
		},
	];

	return (
		<section className={styles.section} id='features'>
			{/* The hero/problem contour artwork, continuing down the right edge. */}
			<ContourBackdrop className={styles.contours} rings={7} from={3.4} />

			<div className={styles.header}>
				<h2 className={styles.title}>
					{intl.formatMessage({ id: 'KeyFeaturesId2' })}
				</h2>
				<p className={styles.subtitle}>
					{intl.formatMessage({ id: 'KeyFeaturesId1' })}
				</p>
			</div>

			<div className={styles.grid}>
				{features.map((feature, index) => {
					const Icon = feature.icon;
					return (
						<article key={index} className={styles.featureCard}>
							<div className={styles.iconContainer}>
								<Icon className={styles.icon} strokeWidth={1.6} />
							</div>
							<h3 className={styles.featureTitle}>{feature.title}</h3>
							<p className={styles.featureDescription}>{feature.description}</p>
						</article>
					);
				})}
			</div>
		</section>
	);
};

export default KeyFeaturesSection;
